module.exports = __webpack_public_path__ + "fonts/Inter-100-greek7.3a3cf1a.woff2";